


//Change transcript state based on current css
const transcriptLink = document.querySelector('.transcript-link-wrapper');

if (transcriptLink != null) {
    transcriptLink.addEventListener('click', () => {
        openCloseTranscript(transcriptLink);
    })

    transcriptLink.addEventListener('keydown', () => {
        if (event.keyCode === 13) {
            openCloseTranscript(transcriptLink);
        }
    })
}



function openCloseTranscript(link) {
    const transcriptState = document.querySelector('.transcript');
    if (transcriptState.classList.length) {
        if (transcriptState.classList.contains("show")) {
            transcriptState.classList.remove("show");
            link.classList.remove("expanded");
        } else {
            transcriptState.classList.add("show");
            link.classList.add("expanded");
        }
    } else {
        transcriptState.classList.add("show");
        link.classList.add("expanded");
    }
}
